<template>
  <div class="avatarImg" id="avatar"></div>
</template>

<script>
import {
  confirmAvatar,
  confirmUserAvatar,
  uploadAvatar,
  uploadUserAvatar
} from '@/api/avatar'
import { Avatar } from 'element-ui'

export default {
  data() {
    // getAvatarList().then(res => {
    //   this.img = getAvatarListMock();
    // });
    return {
      imgs: {},
      selectIndexs: {
        'nation-flag': 0,
        body: 0,
        'nation-uniform': 0,
        pants: 0,
        hair: 0,
        eyes: 0,
        mouth: 0
      },
      currentImgs: {
        'nation-flag': -1,
        body: -1,
        'nation-uniform': -1,
        pants: -1,
        hair: -1,
        eyes: -1,
        mouth: -1
      },
      canvas: null
    }
  },
  mounted() {
    console.error(111)
  },
  methods: {
    initData(imgs, indexs) {
      this.imgs = imgs
      if (indexs) this.selectIndexs = indexs
      this.drawImg()
    },
    changeNation(index) {
      this.selectIndexs['nation-flag'] = index
      this.selectIndexs['nation-uniform'] = index
      this.drawImg()
    },
    changeBody(index) {
      this.selectIndexs['body'] = index
      this.drawImg()
    },
    changePants(index) {
      this.selectIndexs['pants'] = index
      this.drawImg()
    },
    changeHair(index) {
      this.selectIndexs['hair'] = index
      this.drawImg()
    },
    changeEyes(index) {
      this.selectIndexs['eyes'] = index
      this.drawImg()
    },
    changeMouth(index) {
      this.selectIndexs['mouth'] = index
      this.drawImg()
    },
    mintImg(callback) {
      this.drawImg(true, () => {
        this.canvas.canvas.toBlob((blob) => {
          let file = new File([blob], 'test.jpg', { type: 'image/jpeg' })
          uploadAvatar({ image_file: file }).then((res) => {
            if (res.data.path) {
              confirmAvatar({
                super_image: res.data.path,
                image_params: JSON.stringify({
                  body: this.imgs['nation'][this.selectIndexs['nation-flag']]
                    .id,
                  nation: this.imgs['body'][this.selectIndexs['body']].id,
                  // pants: this.imgs['pants'][this.selectIndexs['pants']].id,
                  hair: this.imgs['hair'][this.selectIndexs['hair']].id,
                  eyes: this.imgs['eyes'][this.selectIndexs['eyes']].id,
                  mouth: this.imgs['mouth'][this.selectIndexs['mouth']].id
                })
              })
                .then((_) => {
                  if (callback) callback(_.data)
                })
                .catch((err) => {
                  console.log(err)
                })
            }
          })
        }, 'image/jpeg')
      })
    },
    mintUserImg(callback) {
      this.drawImg(true, () => {
        this.canvas.canvas.toBlob((blob) => {
          let file = new File([blob], 'test.jpg', { type: 'image/jpeg' })
          uploadUserAvatar({ image_file: file }).then((res) => {
            if (res.data.path) {
              confirmUserAvatar({
                super_image: res.data.path,
                image_params: JSON.stringify({
                  body: this.imgs['nation'][this.selectIndexs['nation-flag']]
                    .id,
                  nation: this.imgs['body'][this.selectIndexs['body']].id,
                  // pants: this.imgs['pants'][this.selectIndexs['pants']].id,
                  hair: this.imgs['hair'][this.selectIndexs['hair']].id,
                  eyes: this.imgs['eyes'][this.selectIndexs['eyes']].id,
                  mouth: this.imgs['mouth'][this.selectIndexs['mouth']].id
                })
              }).then((_) => {
                if (callback) {
                  callback(_.data)
                }
              })
            }
          })
        }, 'image/jpeg')
      })
    },
    getNationFlagURL() {
      return this.imgs['nation'][this.selectIndexs['nation-flag']]['flag-image']
    },
    getBodyURL() {
      return this.imgs['body'][this.selectIndexs['body']]['image']
    },
    getNationUniformURL() {
      return this.imgs['nation'][this.selectIndexs['nation-uniform']][
        'uniform-image'
      ]
    },
    getPantsURL() {
      return this.imgs['pants'][this.selectIndexs['pants']]['image']
    },
    getHairURL() {
      return this.imgs['hair'][this.selectIndexs['hair']]['image']
    },
    getEyesURL() {
      return this.imgs['eyes'][this.selectIndexs['eyes']]['image']
    },
    getMouthURL() {
      return this.imgs['mouth'][this.selectIndexs['mouth']]['image']
    },
    drawImg(needFrontCover, callback) {
      if (!this.canvas) {
        var memCanvas = document.createElement('canvas')
        memCanvas.width = '880'
        memCanvas.height = '1200'
        this.canvas = memCanvas.getContext('2d')
        document.querySelector('#avatar').appendChild(memCanvas)
      }
      const cacheImage = {}
      var cacheImageURL = [
        this.$store.state.imgUrl + this.getNationFlagURL(),
        this.$store.state.imgUrl + this.getBodyURL(),
        this.$store.state.imgUrl + this.getNationUniformURL(),
        // this.$store.state.imgUrl + this.getPantsURL(),
        this.$store.state.imgUrl + this.getHairURL(),
        this.$store.state.imgUrl + this.getEyesURL(),
        this.$store.state.imgUrl + this.getMouthURL()
      ]
      if (needFrontCover)
        cacheImageURL.push(
          this.$store.state.imgUrl + this.imgs['frontcover'][0].image
        )
      // cacheImageURL = [
      //   'https://gimg3.baidu.com/search/src=https%3A%2F%2Fbkimg.cdn.bcebos.com%2Fsmart%2F4e4a20a4462309f7d29a77f0790e0cf3d6cad65f-bkimg-process%2Cv_1%2Crw_1%2Crh_1%2Cmaxl_300%2Cpad_1&refer=http%3A%2F%2Fwww.baidu.com&app=2021&size=f256,256&n=0&g=0n&q=100&fmt=auto?sec=1664643600&t=4b99e48f0dee3901002ac9f6b507bdb1'
      // ]
      cacheImageURL.forEach((imgURL) => {
        this.loadImage(imgURL).then((img) => {
          cacheImage[img.src] = img
          if (Object.keys(cacheImage).length === cacheImageURL.length) {
            cacheImageURL.forEach((url) =>
              this.canvas.drawImage(cacheImage[url], 0, 0, 880, 1200)
            )
            if (callback) callback()
          }
        })
      })
    },
    loadImage: (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = () => reject(new Error(`load ${url} fail`))
        img.crossOrigin = 'anonymous'
        img.src = url
      })
    }
  }
}
</script>
<style lang="scss">
.avatarImg {
  canvas {
    width: 1.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Avatar.vue